import style from "../RoundVideoResultThree/CSS/RoundVideoResult.module.css";
import Round from "../RoundVideoResultThree/Component/Round";
import Title from "../RoundVideoResultThree/Component/Title";
import SubTitle from "../RoundVideoResultThree/Component/SubTitle";
import Banner from "../RoundVideoResultThree/Component/Banner";
import coverPhoto from "../RoundVideoResultThree/img/banner.png";
import Slider from "../RoundVideoResultThree/Component/Slider";
import Card from "../RoundVideoResultThree/Component/Card";
import Comment from "../RoundVideoResultThree/Component/Comment";
import Button from "../RoundVideoResultThree/Component/Button";

import sliderOne from "../RoundVideoResultThree/img/sliderOne.png";
import sliderTwo from "../RoundVideoResultThree/img/sliderThree.png";
import sliderThree from "../RoundVideoResultThree/img/sliderTwo.png";
import sliderFour from "../RoundVideoResultThree/img/sliderOne.png";
import sliderFive from "../RoundVideoResultThree/img/sliderTwo.png";
import sliderSix from "../RoundVideoResultThree/img/sliderThree.png";

const sliders = [
  { slider: sliderOne },
  { slider: sliderTwo },
  { slider: sliderThree },
  { slider: sliderFour },
  { slider: sliderFive },
  { slider: sliderSix },
];

const RoundVideoResultThree = () => {
  return (
    <>
      <div className={style.section}>
        <Round round={"01"} status={"running"} />
        <Round round={"02"} status={"pending"} />
        <Round round={"03"} status={"pending"} />
        <Round round={"04"} status={"pending"} />
        <Round round={"05"} status={"pending"} />
        <Round round={"06"} status={"pending"} />
      </div>

      <div>
        <Title title={"round status"} />
      </div>

      <div>
        <SubTitle subTitle={"submitted content"} />
      </div>

      <div>
        <Banner
          title={"1st round time duration june 25 - july 30"}
          coverPhoto={coverPhoto}
        />
      </div>

      <div>
        <Title title={"audition round-1"} />
      </div>

      <div>
        <SubTitle subTitle={"total video - 75"} />
      </div>

      <div>
        <Slider sliders={sliders} />
      </div>

      <div>
        <Title title={"round1 - final result"} />
      </div>

      <div className={style.section}>
        <Card number={"300"} title={"selected user from jury result"} />
        <Card number={"50"} title={"quality next round user result"} />
        <Card number={"250"} title={"rejected video result"} />
      </div>

      <div className={style.comment__section}>
        <Comment title={"congratulation your are selected for the 3rd round"} />
        <Comment title={"your are rejected for the audition"} />
      </div>

      <div style={{ margin: "40px 0px 40px", textAlign: "center" }}>
        <Button text={"Approved Request For Manager"} />
      </div>
    </>
  );
};

export default RoundVideoResultThree;
